import React from 'react'
import { Select, DatePicker, Checkbox, Typography } from 'antd'
import moment from 'moment'
import { IBestDataset } from '../../../../../../types/analytics'
import { DateFormat } from '../../../../../../utils/StaticVariable'
import styles from '../../Layout/AnalyticsLayout.module.scss'

const { Text } = Typography

interface PersistenceInputFormProps {
  pointOption: { label: string, value: string }[]
  categoryDataset: IBestDataset[]
  dataset: string
  onSelectDataset: (value: string) => void
  categories: string[]
  variablesX: any[]
  variableX: any
  onVariableChange: (value: any) => void
  startDate: moment.Moment
  endDate: moment.Moment
  onStartDateChange: (date: any) => void
  onEndDateChange: (date: any) => void
  disabledStartDate: (date: any) => boolean
  disabledEndDate: (date: any) => boolean
  isForAllAnalytics: boolean
  onCheckboxChange: () => void
  isLoading: boolean
  hasError: boolean
  isOfflineDataset: boolean

}

export default function PersistenceInputForm({
   categoryDataset,
   dataset,
   onSelectDataset,
   categories,
   variablesX,
   variableX,
   onVariableChange,
   startDate,
   endDate,
   onStartDateChange,
   onEndDateChange,
   disabledStartDate,
   disabledEndDate,
   isForAllAnalytics,
   onCheckboxChange,
   isLoading,
   hasError,
    isOfflineDataset
 }: PersistenceInputFormProps) {
  return (
    <div className={styles.formRow}>
      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Dataset</Text>
        <Select
          id="Analytics-Persistence-Dataset_Input"
          value={dataset}
          onChange={onSelectDataset}
          placeholder="Select dataset"
          disabled={isLoading || hasError}
        >
          {categories.map((category: string) => (
            <Select.OptGroup key={category} label={category}>
              {categoryDataset
                .filter((item) => item.label === category)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.value}
                  </Select.Option>
                ))}
            </Select.OptGroup>
          ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.variableItem}`}>
        <Text>Variable</Text>
        <Select
          id="Analytics-Persistence-Variable_Input"
          placeholder="Select variable"
          onChange={onVariableChange}
          value={variableX?.Index ? variableX.Index : 0}
          disabled={isOfflineDataset ||isLoading || hasError}
        >
          {variablesX.map((item) => (
            <Select.Option key={item.Index} value={item.Index}>
              {item.Name}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.dateItem}`}>
        <Text>Start Date</Text>
        <DatePicker
          id="Analytics-Persistence-StartDate_Input"
          value={moment(startDate)}
          disabledDate={disabledStartDate}
          onChange={onStartDateChange}
          format={DateFormat}
          disabled={isOfflineDataset ||isLoading || hasError}
        />
      </div>

      <div className={`${styles.formItem} ${styles.dateItem}`}>
        <Text>End Date</Text>
        <DatePicker
          id="Analytics-Persistence-EndDate_Input"
          value={moment(endDate)}
          disabledDate={disabledEndDate}
          onChange={onEndDateChange}
          format={DateFormat}
          disabled={isOfflineDataset ||isLoading || hasError}
        />
      </div>

      <div className={`${styles.formItem} ${styles.checkboxItem}`}>
        <Checkbox
          id="Analytics-Persistence-Checkbox"
          disabled={isOfflineDataset ||hasError || isLoading}
          checked={isForAllAnalytics}
          onChange={onCheckboxChange}
        />
        <Text onClick={onCheckboxChange} style={{ cursor: 'pointer' }}>
          Use this period for all analytics
        </Text>
      </div>
    </div>
  )
}
